import React from "react";
import { motion } from "framer-motion";
import { useCart } from "../../hooks";
import LineItemSlideOut from "./components/LineItemSlideOut";
import CheckoutButton from "./components/CheckoutButton";

// FYI the full page cart is in pages/cart :)
export default function SlideOutCart() {
  const {
    showCart,
    closeCart,
    lineItems,
    totalPrice,
    interactWithCart,
  } = useCart();
  const variants = {
    open: { opacity: 1, x: 0 },
    closed: { opacity: 0, x: "100%" },
    open_bg: { opacity: 0.2, display: "block" },
    closed_bg: { opacity: 0, display: "none" },
  };

  return (
    <div className="hds-text-color">
      <motion.div
        onClick={closeCart}
        className="absolute inset-0 min-h-screen bg-black z-30"
        animate={showCart ? "open_bg" : "closed_bg"}
        initial="closed_bg"
        variants={variants}
      />
      <motion.div
        onMouseOver={interactWithCart}
        animate={showCart ? "open" : "closed"}
        variants={variants}
        className="w-80 bg-white opacity-0 fixed top-0 inset-y-0 overflow-y-scroll right-0 border-l z-50 hide-scroll"
      >
        <div className="bg-white border-b-2 text-primary flex justify-between items-center p-sm">
          <h2 className="text-primary hds-copy font-heading uppercase font-bold">
            SHOPPING CART
          </h2>
          <button
            className="hds-title__medium"
            type="button"
            onClick={closeCart}
          >
            ×
          </button>
        </div>
        {lineItems.length ? (
          <div>
            <div className="flex-grow p-sm overflow-auto mini-cart-section-height hide-scroll">
              {lineItems &&
                lineItems.map((item) => (
                  <LineItemSlideOut key={item.id} item={item} />
                ))}
            </div>
            <div className="p-sm border-t-2 fixed bottom-0 left-0 right-0 bg-white">
              <div className="hds-copy flex justify-between flex-wrap mb-sm">
                <p>Total price:</p>
                <p className="font-bold">${totalPrice}</p>
              </div>
              <CheckoutButton />
            </div>
          </div>
        ) : (
          <div className="my-md text-center">
            There are no items in your cart.
          </div>
        )}
      </motion.div>
    </div>
  );
}
